export default "__VITE_ASSET__5d746957__"